module.exports = __webpack_public_path__ + "static/img/meipai.com.png_160x160.ec6e2fe9.png";